import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { SegmentPool_instanceps1mclk6cv3l as SegmentPool_instance } from './SegmentPool.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { arrayCopytctsywo3h7gj as arrayCopy } from '../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  toByte4i43936u611k as toByte,
  toShort36kaw0zjdq3ex as toShort,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.r4g_1 = 8192;
        this.s4g_1 = 1024;
      }
      t4g() {
        return Segment().u4g();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function init_kotlinx_io_Segment(_this__u8e3s4) {
  _this__u8e3s4.s4e_1 = 0;
  _this__u8e3s4.t4e_1 = 0;
  _this__u8e3s4.u4e_1 = null;
  _this__u8e3s4.v4e_1 = false;
  _this__u8e3s4.w4e_1 = null;
  _this__u8e3s4.x4e_1 = null;
}
var SegmentClass;
function Segment() {
  if (SegmentClass === VOID) {
    class $ {
      w4f() {
        var tmp0_safe_receiver = this.u4e_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v4g();
        return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
      }
      static u4g() {
        var $this = createThis(this);
        init_kotlinx_io_Segment($this);
        $this.r4e_1 = new Int8Array(8192);
        $this.v4e_1 = true;
        $this.u4e_1 = null;
        return $this;
      }
      static w4g(data, pos, limit, shareToken, owner) {
        var $this = createThis(this);
        init_kotlinx_io_Segment($this);
        $this.r4e_1 = data;
        $this.s4e_1 = pos;
        $this.t4e_1 = limit;
        $this.u4e_1 = shareToken;
        $this.v4e_1 = owner;
        return $this;
      }
      e4f() {
        var tmp0_elvis_lhs = this.u4e_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = SegmentPool_instance.x4g();
          this.u4e_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var t = tmp;
        var tmp_0 = this.s4e_1;
        var tmp_1 = this.t4e_1;
        // Inline function 'kotlin.also' call
        t.y4g();
        return Segment().w4g(this.r4e_1, tmp_0, tmp_1, t, false);
      }
      z4f() {
        var result = this.w4e_1;
        if (!(this.x4e_1 == null)) {
          ensureNotNull(this.x4e_1).w4e_1 = this.w4e_1;
        }
        if (!(this.w4e_1 == null)) {
          ensureNotNull(this.w4e_1).x4e_1 = this.x4e_1;
        }
        this.w4e_1 = null;
        this.x4e_1 = null;
        return result;
      }
      f4f(segment) {
        segment.x4e_1 = this;
        segment.w4e_1 = this.w4e_1;
        if (!(this.w4e_1 == null)) {
          ensureNotNull(this.w4e_1).x4e_1 = segment;
        }
        this.w4e_1 = segment;
        return segment;
      }
      x4f(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount > 0 && byteCount <= (this.t4e_1 - this.s4e_1 | 0))) {
          var message = 'byteCount out of range';
          throw IllegalArgumentException().n2(toString(message));
        }
        var prefix;
        if (byteCount >= 1024) {
          prefix = this.e4f();
        } else {
          prefix = SegmentPool_instance.f3w();
          var tmp0 = this.r4e_1;
          var tmp2 = prefix.r4e_1;
          var tmp5 = this.s4e_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = this.s4e_1 + byteCount | 0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
        }
        prefix.t4e_1 = prefix.s4e_1 + byteCount | 0;
        this.s4e_1 = this.s4e_1 + byteCount | 0;
        if (!(this.x4e_1 == null)) {
          ensureNotNull(this.x4e_1).f4f(prefix);
        } else {
          prefix.w4e_1 = this;
          this.x4e_1 = prefix;
        }
        return prefix;
      }
      g4f() {
        // Inline function 'kotlin.check' call
        if (!!(this.x4e_1 == null)) {
          var message = 'cannot compact';
          throw IllegalStateException().o(toString(message));
        }
        if (!ensureNotNull(this.x4e_1).v4e_1)
          return this;
        var byteCount = this.t4e_1 - this.s4e_1 | 0;
        var availableByteCount = (8192 - ensureNotNull(this.x4e_1).t4e_1 | 0) + (ensureNotNull(this.x4e_1).w4f() ? 0 : ensureNotNull(this.x4e_1).s4e_1) | 0;
        if (byteCount > availableByteCount)
          return this;
        var predecessor = this.x4e_1;
        this.y4f(ensureNotNull(predecessor), byteCount);
        var successor = this.z4f();
        // Inline function 'kotlin.check' call
        if (!(successor == null)) {
          throw IllegalStateException().o('Check failed.');
        }
        SegmentPool_instance.g4g(this);
        return predecessor;
      }
      c4g(byte) {
        var _unary__edvuaz = this.t4e_1;
        this.t4e_1 = _unary__edvuaz + 1 | 0;
        this.r4e_1[_unary__edvuaz] = byte;
      }
      e4g(short) {
        var data = this.r4e_1;
        var limit = this.t4e_1;
        var _unary__edvuaz = limit;
        limit = _unary__edvuaz + 1 | 0;
        data[_unary__edvuaz] = toByte((short >>> 8 | 0) & 255);
        var _unary__edvuaz_0 = limit;
        limit = _unary__edvuaz_0 + 1 | 0;
        data[_unary__edvuaz_0] = toByte(short & 255);
        this.t4e_1 = limit;
      }
      z4e() {
        var _unary__edvuaz = this.s4e_1;
        this.s4e_1 = _unary__edvuaz + 1 | 0;
        return this.r4e_1[_unary__edvuaz];
      }
      b4f() {
        var data = this.r4e_1;
        var pos = this.s4e_1;
        var _unary__edvuaz = pos;
        pos = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlinx.io.and' call
        var tmp = (data[_unary__edvuaz] & 255) << 8;
        var _unary__edvuaz_0 = pos;
        pos = _unary__edvuaz_0 + 1 | 0;
        // Inline function 'kotlinx.io.and' call
        var tmp$ret$1 = data[_unary__edvuaz_0] & 255;
        var s = toShort(tmp | tmp$ret$1);
        this.s4e_1 = pos;
        return s;
      }
      y4f(sink, byteCount) {
        // Inline function 'kotlin.check' call
        if (!sink.v4e_1) {
          var message = 'only owner can write';
          throw IllegalStateException().o(toString(message));
        }
        if ((sink.t4e_1 + byteCount | 0) > 8192) {
          if (sink.w4f())
            throw IllegalArgumentException().od();
          if (((sink.t4e_1 + byteCount | 0) - sink.s4e_1 | 0) > 8192)
            throw IllegalArgumentException().od();
          var tmp0 = sink.r4e_1;
          var tmp2 = sink.r4e_1;
          var tmp5 = sink.s4e_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = sink.t4e_1;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
          sink.t4e_1 = sink.t4e_1 - sink.s4e_1 | 0;
          sink.s4e_1 = 0;
        }
        var tmp0_0 = this.r4e_1;
        var tmp2_0 = sink.r4e_1;
        var tmp4 = sink.t4e_1;
        var tmp6 = this.s4e_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_0 = this.s4e_1 + byteCount | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_0 = tmp0_0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp_0, tmp2_0, tmp4, tmp6, endIndex_0);
        sink.t4e_1 = sink.t4e_1 + byteCount | 0;
        this.s4e_1 = this.s4e_1 + byteCount | 0;
      }
      k4f(dst, dstStartOffset, dstEndOffset) {
        var len = dstEndOffset - dstStartOffset | 0;
        var tmp0 = this.r4e_1;
        var tmp6 = this.s4e_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex = this.s4e_1 + len | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp = tmp0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp, dst, dstStartOffset, tmp6, endIndex);
        this.s4e_1 = this.s4e_1 + len | 0;
      }
      u4f(src, srcStartOffset, srcEndOffset) {
        var tmp2 = this.r4e_1;
        // Inline function 'kotlin.collections.copyInto' call
        var destinationOffset = this.t4e_1;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp = src;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp, tmp2, destinationOffset, srcStartOffset, srcEndOffset);
        this.t4e_1 = this.t4e_1 + (srcEndOffset - srcStartOffset | 0) | 0;
      }
      q2() {
        return this.t4e_1 - this.s4e_1 | 0;
      }
      t4f() {
        return this.r4e_1.length - this.t4e_1 | 0;
      }
      z4g(readOnly) {
        return this.r4e_1;
      }
      i4f(index) {
        return this.r4e_1[this.s4e_1 + index | 0];
      }
      a4h(index, value) {
        this.r4e_1[this.t4e_1 + index | 0] = value;
      }
      b4h(index, b0, b1) {
        var d = this.r4e_1;
        var l = this.t4e_1;
        d[l + index | 0] = b0;
        d[(l + index | 0) + 1 | 0] = b1;
      }
      c4h(index, b0, b1, b2) {
        var d = this.r4e_1;
        var l = this.t4e_1;
        d[l + index | 0] = b0;
        d[(l + index | 0) + 1 | 0] = b1;
        d[(l + index | 0) + 2 | 0] = b2;
      }
      d4h(index, b0, b1, b2, b3) {
        var d = this.r4e_1;
        var l = this.t4e_1;
        d[l + index | 0] = b0;
        d[(l + index | 0) + 1 | 0] = b1;
        d[(l + index | 0) + 2 | 0] = b2;
        d[(l + index | 0) + 3 | 0] = b3;
      }
    }
    initMetadataForClass($, 'Segment');
    SegmentClass = $;
  }
  return SegmentClass;
}
function isEmpty(_this__u8e3s4) {
  return _this__u8e3s4.q2() === 0;
}
var SegmentCopyTrackerClass;
function SegmentCopyTracker() {
  if (SegmentCopyTrackerClass === VOID) {
    class $ {}
    initMetadataForClass($, 'SegmentCopyTracker');
    SegmentCopyTrackerClass = $;
  }
  return SegmentCopyTrackerClass;
}
var AlwaysSharedCopyTrackerClass;
function AlwaysSharedCopyTracker() {
  if (AlwaysSharedCopyTrackerClass === VOID) {
    class $ extends SegmentCopyTracker() {
      constructor() {
        AlwaysSharedCopyTracker_instance = null;
        super();
        AlwaysSharedCopyTracker_instance = this;
      }
      v4g() {
        return true;
      }
      y4g() {
        return Unit_instance;
      }
    }
    initMetadataForObject($, 'AlwaysSharedCopyTracker');
    AlwaysSharedCopyTrackerClass = $;
  }
  return AlwaysSharedCopyTrackerClass;
}
var AlwaysSharedCopyTracker_instance;
function AlwaysSharedCopyTracker_getInstance() {
  if (AlwaysSharedCopyTracker_instance === VOID)
    new (AlwaysSharedCopyTracker())();
  return AlwaysSharedCopyTracker_instance;
}
function indexOf(_this__u8e3s4, byte, startOffset, endOffset) {
  // Inline function 'kotlin.require' call
  if (!(0 <= startOffset ? startOffset < _this__u8e3s4.q2() : false)) {
    var message = '' + startOffset;
    throw IllegalArgumentException().n2(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(startOffset <= endOffset ? endOffset <= _this__u8e3s4.q2() : false)) {
    var message_0 = '' + endOffset;
    throw IllegalArgumentException().n2(toString(message_0));
  }
  var p = _this__u8e3s4.s4e_1;
  var data = _this__u8e3s4.z4g(true);
  var inductionVariable = startOffset;
  if (inductionVariable < endOffset)
    do {
      var idx = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (data[p + idx | 0] === byte) {
        return idx;
      }
    }
     while (inductionVariable < endOffset);
  return -1;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  AlwaysSharedCopyTracker_getInstance as AlwaysSharedCopyTracker_getInstance1rs3z6uqvhgfu,
  Companion_instance as Companion_instancecsbm5ewxyfnq,
  indexOf as indexOf1i2yqitz2lwb6,
  isEmpty as isEmpty39cntv762vey6,
};
//endregion

//# sourceMappingURL=Segment.mjs.map
